module.exports = __webpack_public_path__ + "img/tool.24580be8.svg";